/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useRef, useState } from "react";
import styles from "../styles.module.scss";
import Select from "react-select";
import { selectStyle } from "../../../../../../../../components/InputSelectAsync";
import { LuPackageX } from "react-icons/lu";
import Title from "./Title";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";

export const NoDelivery = ({
  handleSubmit,
  handleBackButton,
  defaultValue,
  error,
  options,
  onChange,
  setReceiverData,
  setEvidenceImage,
  evidenceImage,
  evidenceError,
  setEvidenceError,
  needEvidence
}) => {

  const [imgPreview, setImgPreview] = useState()

  const fileInputRef = useRef(null)

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setEvidenceImage(file);
    }
  };

  useEffect(() => {
    if (evidenceImage && typeof evidenceImage !== "string") {
      setImgPreview(URL.createObjectURL(evidenceImage))
      setEvidenceError(undefined)
    }
  }, [evidenceImage])

  return (
    <>
      <div>
        <Title text={"Marcar como coleta não realizada"} icon={<LuPackageX color="#ff6b71" size={40} />} />
        <div className={styles.formContainer}>
          <div className={styles.formSelect}>
            <span>Selecionar Motivo <strong style={{ color: "#eb0014" }}>*</strong></span>
            <div className={styles.select}>
              <Select
                onChange={onChange}
                options={options}
                value={defaultValue}
                placeholder="Nenhum motivo selecionado"
                styles={selectStyle}
                className={styles.select}
              />
              {error && <span className={styles.formErrorMsg}>{error}</span>}
            </div>
          </div>

          {needEvidence && (<>
            {(imgPreview) ?
              (<div className={styles.imageContainer}>
                <div className={styles.image}>
                  <TransformWrapper>
                    <TransformComponent>
                      <img
                        src={imgPreview}
                        alt="Imagem do objeto entregue"
                      />
                    </TransformComponent>
                  </TransformWrapper>
                </div>
              </div>) : (
                <div className={styles.emptyImage}>
                  <p>Nenhuma imagem carregada</p>
                </div>
              )}

            <div className={styles.imageForm}>
              <div className={styles.inputFileContainer}>
                <div
                  className={`${styles.inputFile}`}
                  onClick={handleButtonClick}
                >
                  <span>
                    Inserir imagem
                  </span>
                </div>
              </div>
              <span className={styles.evidenceErrorMsg}>{evidenceError}</span>
              <input type="file" accept="image/*" ref={fileInputRef} style={{ display: "none" }} onChange={handleImageChange} />
            </div>
          </>)}
        </div>

        <div className={styles.buttonContainer}>
          <button
            type="button"
            onClick={handleBackButton}
            className={styles.buttonBack}
          >
            Voltar
          </button>

          <button onClick={handleSubmit} disabled={!!error || evidenceError}>
            Salvar
          </button>
        </div>
      </div>
    </>
  );
};
